import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../context/AuthContext";

export default function FooterPages() {
  const [pages, setPages] = useState([]);
  useEffect(() => { axios.get(`${API}/site/pages`).then(r => setPages(r.data)).catch(() => {}); }, []);
  if (!pages.length) return null;
  return (
    <div className="flex flex-wrap justify-center gap-4 normal-case tracking-normal" data-testid="footer-pages">
      {pages.map(p => <Link key={p.slug} to={`/p/${p.slug}`} className="hover:text-white" data-testid={`footer-page-${p.slug}`}>{p.title}</Link>)}
    </div>
  );
}
